<script setup>
import TvScorebug from '~/components/tv/TvScorebug.vue';
import {TV_COMPETITION_ICON, tvPages, tvPageSize} from '~/utils/tvDisplay';

// Matches being scored right now, as scorebugs: games won so far, then the
// current game's points. Only in the rotation while something is live.
const props = defineProps({
  matches: {type: Array, default: () => []},
  page: {type: Number, default: 0},
});
// wide, column or portrait (set by the panel's frame)
const mode = inject('tvMode', ref('wide'));

const rows = computed(() => tvPages(props.matches, tvPageSize('live', mode.value))[props.page] ?? []);

const asResult = (match) => {
  let state = null;
  try { state = match.state ? JSON.parse(match.state) : null; } catch (e) { state = null; }
  const path = state?.path ?? [];
  const root = path.length > 1 ? path[0] : null;
  const leaf = path[path.length - 1];
  const done = Object.values(state?.completedUnits ?? {}).flat()
      .filter(u => u.unit === path[path.length - 1]?.unit);
  return {
    homeTeamName: match.homeTeamName,
    awayTeamName: match.awayTeamName,
    homeResult: root?.home ?? leaf?.homeDisplay ?? leaf?.home ?? 0,
    awayResult: root?.away ?? leaf?.awayDisplay ?? leaf?.away ?? 0,
    // finished games, then the one in play
    games: root ? [...done.map(u => ({home: u.home, away: u.away})),
      {home: leaf?.homeDisplay ?? leaf?.home ?? 0, away: leaf?.awayDisplay ?? leaf?.away ?? 0}] : [],
  };
};
</script>

<template>
  <div class="tv-live">
    <div v-for="match in rows" :key="match.sessionId" class="tv-live-item">
      <div class="tv-live-meta">
        <span class="tv-live-tag">Live</span>
        <v-icon :icon="TV_COMPETITION_ICON[match.competitionKind]" size="24"/>
        <span class="tv-live-comp">{{ match.competitionName }}</span>
        <span v-if="match.playingAreaName" class="tv-live-court">{{ match.playingAreaName }}</span>
      </div>
      <tv-scorebug :result="asResult(match)" size="list" class="tv-live-bug"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tv-live {
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.tv-live-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 22px;
  color: var(--tv-muted);
}

.tv-live-tag {
  padding: 0 10px;
  border-radius: 4px;
  background: #e0243c;
  color: #fff;
  font-weight: 600;
}

.tv-live-comp {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tv-live-court {
  margin-left: auto;
  font-weight: 600;
  color: var(--tv-ink);
}

.tv-live-bug {
  --bug-row: 60px;
  --bug-font: 34px;
  --bug-score: 40px;
  --bug-cell: 64px;
}
</style>
